import React, { useState, Suspense, lazy } from 'react';
import {
  Switch,
  Route,
  Redirect,
  useParams
} from "react-router-dom";

import LocaleContext from 'contexts/locale-context';
import NotificationContext from 'contexts/notification-context';

import Notification from 'components/notification';


import translations from 'translations';

// const Home = lazy(() => import('pages/home'));
// const Download = lazy(() => import('pages/download'));
// const PrivacyPolicy = lazy(() => import('pages/privacy-policy'));
// const TermsOfUse = lazy(() => import('pages/terms-of-use'));

// const AuthRedirect = lazy(() => import('pages/auth_redirect'));

import Home from 'pages/home';
import Download from 'pages/download';
import PrivacyPolicy from 'pages/privacy-policy';
import TermsOfUse from 'pages/terms-of-use';

import AuthRedirect from 'pages/auth_redirect';


const changeLocale = setLocale => locale => {
  if (translations[locale]) {
    setLocale(locale);
  }
}

const Routes = props => {
  const localesString =
  Object.keys(translations).join('|');

  return (
    <div>
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route path={`/auth_redirect`} exact>
            <AuthRedirect />
          </Route>
          <Route
            path="/download(.html)?"
            render={({ location }) =>
              <Redirect
                to={`/en/download${location.search}`}
              />
            }
          />
          <Redirect from='/terms-of-use(.html)?(/index.html)?' to={`/en/terms-of-use(.html)?`} />
          <Redirect from='/privacy-policy(.html)?(/index.html)?' to={`/en/privacy-policy(.html)?`} />
          <Route path={`/:locale(${localesString})`}>
            <Parent {...props} localesString={localesString} />
          </Route>
          <Redirect to='/en' />
        </Switch>
      </Suspense>
    </div>
  );
}

const Parent = ({ translations = {}, localesString }) => {
  const { locale } = useParams();
  const [_locale, setLocale] = useState(translations[locale] ? locale : 'en');
  const [notification, setNotif] = useState({});

  return (
    <LocaleContext.Provider
      value={{
        locale: _locale,
        translations: translations[_locale],
        changeLocale: changeLocale(setLocale)
      }}
    >
      <NotificationContext.Provider
        value={{
          notification,
          setNotification: notif => setNotif(notif)
        }}
      >
        <Notification />
        <Switch>
          <Redirect
            from={`/:locale(${localesString})/privacy-policy/index.html`}
            to={`/:locale/privacy-policy(.html)?`}
          />
          <Redirect
            from={`/:locale(${localesString})/terms-of-use/index.html`}
            to={`/:locale/terms-of-use(.html)?`}
          />
          
          <Route path={`/:locale(${localesString})/download(.html)?(/)?(.index.html)?`} exact>
            <Download />
          </Route>
          <Route path={`/:locale(${localesString})/privacy-policy(.html)?(/)?(.index.html)?`} exact>
            <PrivacyPolicy />
          </Route>
          <Route path={`/:locale(${localesString})/terms-of-use(.html)?(/)?(.index.html)?`} exact>
            <TermsOfUse />
          </Route>
          <Route path={`/:locale(${localesString})(/)?(.index.html)?`} exact>
            <Home />
          </Route>
          <Redirect to='/:locale' />
        </Switch>
      </NotificationContext.Provider>
    </LocaleContext.Provider>
  )
}

export default Routes;